"use client";

import { HoverCard, HoverCardContent } from "@/components/ui/hover-card";
import { HoverCardTrigger } from "@radix-ui/react-hover-card";
import { Header, flexRender } from "@tanstack/react-table";

export default function HeaderCell<T>({
  header,
}: {
  header: Header<T, unknown>;
}) {
  const sorted = header.column.getIsSorted();

  if (sorted) {
    return (
      <>{flexRender(header.column.columnDef.header, header.getContext())}</>
    );
  }

  return (
    <HoverCard openDelay={100}>
      <HoverCardTrigger>
        {flexRender(header.column.columnDef.header, header.getContext())}
      </HoverCardTrigger>
      <HoverCardContent
        align="start"
        className="hidden w-auto max-w-[260px] rounded border border-[#dde2eb] bg-white py-4 shadow-2xl md:block"
        sideOffset={-20}>
        {flexRender(header.column.columnDef.header, header.getContext())}
      </HoverCardContent>
    </HoverCard>
  );
}
